<div class="delete-account-modal-holder" *ngIf="!formCompleted; else successScreen">
    <div class="title-section">
        <h3 [innerHTML]="config?.select_reason?.title"></h3>
        <serviceos-ng-alert class="error-alert" *ngIf="formErrorMessage" [type]="'error'">
            {{ formErrorMessage }}
        </serviceos-ng-alert>
    </div>
    <div class="content-section">
        <p class="title" [innerHTML]="config?.select_reason?.content?.title"></p>
        <div class="content">
            <ul>
                <li *ngFor="let info of config?.select_reason?.content?.items" [innerHTML]="info"></li>
            </ul>
        </div>
        <p class="title" [innerHTML]="config?.select_reason.reason_field_label"></p>
        <div class="content">
            <form
                [formGroup]="accountDeletionForm"
            >
                <serviceos-ng-radio-group
                    formControlName="reason"
                    *ngIf="config?.select_reason?.reasons && config?.select_reason?.reasons?.length"
                >
                    <serviceos-ng-radio
                        [value]="reason"
                        [checked]="reason?.selected"
                        *ngFor="let reason of config?.select_reason?.reasons"
                    >{{ reason.label }}</serviceos-ng-radio
                    >
                </serviceos-ng-radio-group>
                <ng-container *ngIf="accountDeletionForm.get('reason')?.value.requires_comment">
                    <serviceos-ng-form-field>
                        <serviceos-ng-label >{{ config?.select_reason?.comment_field_placeholder }}</serviceos-ng-label>
                        <textarea
                            formControlName="comment"
                            serviceosNgInput
                        ></textarea>
                    </serviceos-ng-form-field>
                </ng-container>
                
                <p class="title" [innerHTML]="config?.select_reason?.password_field_label"></p>
                <serviceos-ng-form-field>
                    <serviceos-ng-label >{{ config?.select_reason?.password_field_placeholder }}</serviceos-ng-label>
                    <input
                        type="password"
                        formControlName="password"
                        serviceosNgInput
                    />
                </serviceos-ng-form-field>
                
                <serviceos-ng-button
                    [isFullWidth]="true"
                    [disable]="accountDeletionForm.errors?.formError"
                    (click)="onFormSubmit()"
                >
                    {{ config?.select_reason?.submit_button_label }}
                </serviceos-ng-button>
            </form>
        </div>
    </div>
</div>
<ng-template #successScreen>
    <div *ngIf="successMessage" class="success-page-holder">
        <div class="message-holder">
            <div class="title">
                <h3 [innerHTML]="config?.thank_you?.success_screen_title"></h3>
            </div>
            <!-- <div class="description">
                <p [innerHTML]="successMessage"></p>
            </div> -->
        </div>
        <div class="buttons-holder">
            <serviceos-ng-button (click)="onSuccessScreenConfirmation()">{{ config?.thank_you?.success_screen_button_label }}</serviceos-ng-button>
        </div>
    </div>
</ng-template>
